import React, { useEffect, useState } from 'react';
import Modal from '@xo-union/tk-component-modals';
import moment from 'moment';

import { Body1, H1 } from '@xo-union/tk-ui-typography';
import { Button } from '@xo-union/tk-component-buttons';
import styles from './styles.scss';
import { useWeddingWebsiteQuery } from '../../generated/graphql';

export const CvMigrationModal: React.FC = () => {
  const { data } = useWeddingWebsiteQuery();
  const [showMigrationModal, setShowMigrationModal] = useState(false);

  useEffect(() => {
    const isLegacyMigrated = data?.weddingWebsite.legacyMigrated || false;
    setShowMigrationModal(isLegacyMigrated && localStorage.getItem('cv1-migrated-modal-seen') === null);
  }, [data]);

  const closeMigrationModal = () => {
    localStorage.setItem('cv1-migrated-modal-seen', moment().toISOString());
    setShowMigrationModal(false);
  };

  if (!showMigrationModal) {
    return null;
  }

  return (
    <Modal onClose={closeMigrationModal}>
      <div className={styles.center}>
        <H1 className={styles.header}>Your website has been updated</H1>
      </div>
      <div>
        <Body1 className={styles.body1}>
          We’ve updated your wedding website template. Here’s what to get excited about!
        </Body1>
        <div className={styles.list}>
          <ul>
            <li>
              <strong>Different content types </strong> you can add to all pages on your website (titles, text boxes,
              photos, galleries, GIFs, etc.)
            </li>
            <li>
              The ability to add <strong>new custom questions</strong> to your RSVP page
            </li>
            <li>
              <strong>Better RSVP visualization </strong>to make tracking responses and meal choices easier
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.center}>
        <Body1 className={styles.questions}>
          Have questions for us? Check out{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://helpcenter.theknot.com/hc/en-us/articles/4415555505812-Wedding-Website-Updates"
          >
            this article
          </a>
          .
        </Body1>

        <Button onClick={closeMigrationModal} color="primary" size="md" className={styles.checkItOut}>
          Check it out
        </Button>
      </div>
    </Modal>
  );
};

export default CvMigrationModal;
